import React, {useEffect, useRef, useState} from 'react';
import {Button, Card, CardBody, CardText, CardTitle, Col, Container, Label, Row} from 'reactstrap';
import Rating from 'react-rating';
// import 'font-awesome/css/font-awesome.min.css';
import ReviewQuestionService from "../../../services/reviewQuestionService";
import ReviewService from "../../../services/reviewService";
import NotificationAlert from "react-notification-alert";
import FormInput from "../../../components/common/form/FormInput";
import UtilService from "../../../services/utilService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as solidStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as regularStar } from '@fortawesome/free-regular-svg-icons';

const ReviewForm = ({surveyDetails, answerId}) => {
    // State to hold the answers as an object: { uniqueId: rating, ... }
    const [answers, setAnswers] = useState({});
    // For error messages if validation fails.
    const [error, setError] = useState('');
    const [mainQuestionList, setMainQuestionList] = useState([]);
    const [questionList, setQuestionList] = useState([]);
    const [reviewTypeSaved, setReviewTypeSaved] = useState({});
    const notificationAlertRef = useRef(null);
    const [invitationStatus, setInvitationStatus] = useState(surveyDetails?.answer?.invitationStatus);
    const [remarks, setRemarks] = useState("");
    const [remarksPublic, setRemarksPublic] = useState(false);

    useEffect(() => {
        ReviewQuestionService.listByTenant().then(response => {
            console.log(surveyDetails);
            console.log(response);
            setMainQuestionList(response);
            console.log("mainQuestionList", mainQuestionList);
            const filteredQuestionList = response.filter(question => question.reviewType === surveyDetails?.answer?.reviewType);
            console.log("filteredQuestionList", filteredQuestionList);
            setQuestionList(filteredQuestionList);
        });
    }, []);

    // Called whenever a rating is changed.
    const handleScoreChange = (uniqueId, score) => {
        setAnswers(prev => ({
            ...prev,
            [uniqueId]: score
        }));
    };

    const handleRemarkChange = (event) => {
        setRemarks(event.target.value)
    }

    // On form submission, validate that all questions are answered.
    const handleSubmit = (e) => {
        e.preventDefault();
        if (Object.keys(answers).length !== questionList.length) {
            notify("Danger", "Error!", "All fields are mandatory");
            return;
        }
        setError('');

        // Build an array of answer objects mapping question uniqueId to answer rating.
        const answerArray = questionList.map(q => ({
            questionId: q.uniqueId,
            answer: answers[q.uniqueId]
        }));

        const data = {
            answerId: answerId,
            answers: answerArray,
            remarks: remarks,
            remarksPublic: remarksPublic,
        }
        console.log("Data", data)
        ReviewService.submitReviewAnswers(data).then(response => {
            console.log(response);
            setInvitationStatus(response.invitationStatus)
        })
    };

    const notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
                    <span className="alert-title" data-notify="title">
                        {title}
                    </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        notificationAlertRef.current.notificationAlert(options);
    };

    return (
        <Container>
            <div className="rna-wrapper">
                <NotificationAlert ref={notificationAlertRef}/>
            </div>
            {invitationStatus === "ANSWERED" ? (<> <h2>Thank You for answering the survey!</h2></>) : (<>
                <h2>Please fill up your review of {surveyDetails?.user?.userCompanyName}!</h2>
                <form onSubmit={handleSubmit}>
                    <Row>
                        <Col md="12" key={UtilService.uuidv4()} className="mb-3">
                        <Card>
                            <CardBody>
                                {questionList.map((question) => (
                                    <div key={question.uniqueId}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'  }}>
                                            <CardTitle tag="h3" style={{marginBottom: "2px"}}>{question.headline}</CardTitle>
                                            <Rating
                                                fractions={2}
                                                initialRating={answers[question.uniqueId] || 0}
                                                onChange={(rate) => handleScoreChange(question.uniqueId, rate)}
                                                emptySymbol={<FontAwesomeIcon icon={regularStar} size="2x" />}
                                                fullSymbol={<FontAwesomeIcon icon={solidStar} size="2x" />}
                                            />
                                        </div>
                                        <CardText style={{marginBottom: "10px"}}>{question.question}</CardText>
                                    </div>
                                ))}
                            </CardBody>
                        </Card>
                    </Col>
                    </Row>
                    <Row>
                        <Col md="12" className="mb-3">
                            <Label><h4>Remarks</h4></Label>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <FormInput
                                    name="reviewsSearchEnabled"
                                    className="form-control-label"
                                    id="reviewsSearchEnabled"
                                    placeholder="Testimonial remark"
                                    type="checkbox"
                                    onChange={(e) => {
                                        setRemarksPublic(e.target.checked)
                                    }}
                                    label=""
                                    checked={remarksPublic}
                                    errorMsg={""}
                                    style={{
                                        // marginRight: '8px', top: "132px"
                                    }}
                                />
                                <label htmlFor="reviewsSearchEnabled" className="form-control-label mb-0">
                                    Please let us know if you have any comments for our consideration. If there is
                                    anything we need to improve in, please let us know. If you’re happy with our
                                    services we’d be delighted to receive your positive remark that we can use as a
                                    testimonial! If you approve for us to use this testimonial, don’t forget to tick the
                                    box
                                </label>
                            </div>

                            <FormInput
                                name="remarks"
                                className="form-control-label"
                                id="remarks"
                                placeholder="Remarks"
                                type="textarea"
                                onChange={handleRemarkChange}
                                label=""
                                value={remarks || ""}
                            />

                        </Col>
                    </Row>
                    <div className="text-center">
                        <Button color="default" outline type="submit">Submit Review</Button>
                    </div>
                </form>
            </>)}


        </Container>
    );
};

export default ReviewForm;
